import { render, staticRenderFns } from "./WithdrawDialog.vue?vue&type=template&id=58daf1ce&scoped=true&"
import script from "./WithdrawDialog.vue?vue&type=script&lang=js&"
export * from "./WithdrawDialog.vue?vue&type=script&lang=js&"
import style0 from "./WithdrawDialog.vue?vue&type=style&index=0&id=58daf1ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58daf1ce",
  null
  
)

export default component.exports